import { render, staticRenderFns } from "./HStudentLeaveSubApplication.vue?vue&type=template&id=01a9de21&scoped=true&"
import script from "./HStudentLeaveSubApplication.vue?vue&type=script&lang=js&"
export * from "./HStudentLeaveSubApplication.vue?vue&type=script&lang=js&"
import style0 from "./HStudentLeaveSubApplication.vue?vue&type=style&index=0&id=01a9de21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a9de21",
  null
  
)

export default component.exports